export const API_ENDPOINT = {
  auth: 'internaldriverintegration/login',
  chartekSearch: 'internaldriverintegration/charteksearch/',
  chartekReport: 'internaldriverintegration/print',
  order: 'externaldriverintegration/order/',
  orderReport: 'externaldriverintegration/print/',
};
